<template>
    <div>
        <h2 class="title is-4">
            Sales Properties
        </h2>

        <FlashNotification />

        <div
            v-if="! properties"
            class="columns is-multiline"
        >
            <SkeletonCard
                classes="is-12-tablet is-4-desktop"
                :count="3"
            />
        </div>

        <Notification v-if="properties && ! hasProperties">
            No properties found.
        </Notification>

        <div
            v-if="properties"
            class="columns is-multiline"
        >
            <SalesProperty
                v-for="property in properties.Rows"
                :key="property.PropertyPK"
                :property="property"
            />
        </div>

        <b-pagination
            v-if="hasProperties && properties.RowCount > limit"
            class="mt-3"
            :total="properties.RowCount"
            :current.sync="page"
            order="is-centered"
            range-before="2"
            range-after="2"
            :per-page="limit"
            @change="searchProperties(false)"
        />
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import FlashNotification from '../components/FlashNotification.vue';
import Notification from '../components/Notification.vue';
import SalesProperty from '../components/SalesProperty.vue';
import SkeletonCard from '../components/SkeletonCard.vue';

export default {
    components: {
        FlashNotification,
        Notification,
        SalesProperty,
        SkeletonCard,
    },

    data: function() {
        return {
            page: Number(this.$route.query.page || 1),
            limit: 9,
        };
    },

    computed: {
        ...mapState('salesProperties', [
            'properties',
        ]),
        ...mapGetters('salesProperties', [
            'hasProperties',
        ]),
    },

    mounted() {
        // reset property in store
        this.$store.dispatch('salesProperty/reset');

        this.getProperties();
    },

    methods: {
        searchProperties(resetPagination = true) {
            if (resetPagination) {
                this.page = 1;
            }

            this.$router.push({
                query: this.$data,
            });

            this.getProperties();
        },
        getProperties() {
            this.$store.dispatch('salesProperties/getRows', this.$data);
        },
    },
};
</script>
